import { AppContextProvider } from "@/context/appContext";
import LearningCompass from "@/learningCompass";
import ErrorBoundary from "./components/ErrorBoundary";

const App = () => {
  return (
    <AppContextProvider>
      <ErrorBoundary>
        <LearningCompass />
      </ErrorBoundary>
    </AppContextProvider>
  );
};

export default App;
